module.exports = __webpack_public_path__ + "img/zhaoshang_wuchang@2x.568e1293.png";